
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as g9KqopjQx_Fg_uzFoIJwbZAbL_zlUN_45y7J7CFZjw4jt4Meta } from "/codebuild/output/src266905323/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexZcZmA0wJJfvI7QZnBW2_KK7V5SB_hYOK5fXsn5w0vvMMeta } from "/codebuild/output/src266905323/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchoij9GaEgNGOFF0UIxHoa_45zOMJxuNFohglGo3v5vMe54Meta } from "/codebuild/output/src266905323/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexahq79P2aMhNekLSaMQ_45_EsTVKw5JlM_45cCm0zLGv9AZMMeta } from "/codebuild/output/src266905323/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93Pcym0HqJf9H56euOsDtegvt4pc3zlvSFN_8g18MNCjoMeta } from "/codebuild/output/src266905323/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexORycvA54o1lJs6141q7Mpz_NfNsylcsj8O1mATf2_7EMeta } from "/codebuild/output/src266905323/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93Z_ZkmGjN0K3fkpLda3wycJG8XoUbnmUk_45fWmowCMVZcMeta } from "/codebuild/output/src266905323/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexWQZoZHaFo_45nERjUkuoK7zjjLAAk5dfKDjqaPyKB6IacMeta } from "/codebuild/output/src266905323/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93QvZhRh4x5S_45CKNQZJ3d_45vVYVJLw1MrhykXqiqT_yqj0Meta } from "/codebuild/output/src266905323/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexltl0EnfPyxhNqoHgU1ncoE6w940HokAKtfvqHPjB7q0Meta } from "/codebuild/output/src266905323/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexKawWnZDirTYeI0Qun4Ew5f7TRPrjrB4DF7KDUy5xdQUMeta } from "/codebuild/output/src266905323/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src266905323/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src266905323/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src266905323/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src266905323/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src266905323/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexORycvA54o1lJs6141q7Mpz_NfNsylcsj8O1mATf2_7EMeta || {},
    component: () => import("/codebuild/output/src266905323/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src266905323/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexWQZoZHaFo_45nERjUkuoK7zjjLAAk5dfKDjqaPyKB6IacMeta || {},
    component: () => import("/codebuild/output/src266905323/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src266905323/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexltl0EnfPyxhNqoHgU1ncoE6w940HokAKtfvqHPjB7q0Meta || {},
    component: () => import("/codebuild/output/src266905323/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexKawWnZDirTYeI0Qun4Ew5f7TRPrjrB4DF7KDUy5xdQUMeta || {},
    component: () => import("/codebuild/output/src266905323/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]